import React, { useContext, useState } from "react";

const SiteDataContext = React.createContext();
export const SiteDataProvider = ({ children }) => {
  const [selectedSite, setSelectedSite] = useState(null);

  return (
    <SiteDataContext.Provider value={{ selectedSite, setSelectedSite }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export default function useSite() {
  const context = useContext(SiteDataContext);
  return context;
}
